import React from "react"
import { graphql } from "gatsby"
import AllCaseStudiesPage from "../../components/caseStudies/AllCaseStudiesPage"
import { STORIES } from "../../data/caseStudies"

/**
 * Each story's photo is queried under an alias equal to the last segment
 * of its `path` (e.g. "/caseStudies/projects/borjan" -> `borjan`), so the
 * query below and this lookup can't drift apart silently — change one and
 * the other still lines up by construction, not by a parallel list kept
 * in sync by hand.
 */
const CaseStudiesIndex = ({ data }) => {
  const photos = {}
  STORIES.forEach(story => {
    const alias = story.path.split("/").pop()
    const gatsbyImageData = data[alias]?.childImageSharp?.gatsbyImageData
    if (gatsbyImageData) {
      photos[story.photoFile] = gatsbyImageData
    }
  })

  const hasPagePaths = new Set(data.allSitePage.nodes.map(n => n.path.replace(/\/$/, "")))

  return <AllCaseStudiesPage photos={photos} hasPagePaths={hasPagePaths} />
}

export default CaseStudiesIndex

export const query = graphql`
  query AllCaseStudiesImages {
    bigJerrysFencing: file(relativePath: { eq: "news/Bigjerryfencing.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    nurturefulPsychology: file(relativePath: { eq: "caseStudies/nurturefulth.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    centricEvents: file(relativePath: { eq: "caseStudies/centricEvents-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    ecoZohm: file(relativePath: { eq: "caseStudies/ecoZohm-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    cakesAndBakes: file(relativePath: { eq: "caseStudies/cakesAndBakes-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    borjan: file(relativePath: { eq: "caseStudies/borjan-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    hushPuppiesPakistan: file(relativePath: { eq: "caseStudies/hushPuppiesPakistan-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    netAtlantic: file(relativePath: { eq: "caseStudies/netAtlantic-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    ttiTestingLaboratories: file(relativePath: { eq: "caseStudies/ttiTestingLaboratories-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    muscatMediaGroup: file(relativePath: { eq: "caseStudies/MuscatMediaGroupoman.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    orangelinePakistan: file(relativePath: { eq: "caseStudies/orangelinetrain1.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    emeAquaticSystems: file(relativePath: { eq: "caseStudies/eme-story1.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    orrProtection: file(relativePath: { eq: "clients/orrProtection-card.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    unitedGulfPipe: file(relativePath: { eq: "clients/unitedGulfPipe-card.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    soharPort: file(relativePath: { eq: "clients/soharPort-card.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    hugeSports: file(relativePath: { eq: "clients/hugeSports-card.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    aamaalGroup: file(relativePath: { eq: "clients/aamaalGroup-card.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    unitedAlZahra: file(relativePath: { eq: "clients/unitedAlZahra-card.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    allSitePage {
      nodes {
        path
      }
    }
  }
`
